import { JobStates } from "./constants";

export const isRestartingState = (state: string) =>
  [JobStates.QUEUED, JobStates.QUEUING].includes(state);

export const isToolkitValidName = (name: string) => {
  const toolkitNameInvalidCharacters = /[^a-zA-Z\d_]/;

  return toolkitNameInvalidCharacters.test(name);
};
